import { injectable, inject } from 'inversify';
import { TYPES } from '@/Framework/config/DI/types';
import { IDataroomTenantConfig } from '@/dataroom/domain/vo/DataroomTenantConfig';
import { DataroomDomainConfig } from '@dataroom/domain/DI/DataroomDomainConfig';
import { DataroomTenant } from '@/dataroom/domain/vo/types/DataroomTenant';
import DataroomTenantConfig from '@/dataroom/application/config/DataroomTenantConfig';

@injectable()
export class ConfigFactory {
  constructor(
    @inject(TYPES.DomainConfig) private domain: DataroomDomainConfig,
  ) {}

  create(tenant: DataroomTenant): IDataroomTenantConfig {
    const baseConfig: IDataroomTenantConfig = DataroomTenantConfig.fromCode(tenant);

    if (!baseConfig) {
      throw new Error(`No base config found for tenant: ${ tenant }`);
    }

    return {
      ...baseConfig,
      hostname: this.domain.getDomain(tenant),
    };
  }
}
